export function validateValidShippingPrice(so, isAdvanced) {
    if (
        so.type == null ||
        so.type === '' ||
        so.type === 'Takeaway' ||
        so.type === 'TakeawayOnly'
    ) {
        return null;
    }
    if (so.cost === null || so.cost === undefined) {
        return isAdvanced ? null : 'Fraktpris saknas';
    }
    if (!isInt(so.cost)) {
        return 'Du får bara ange belopp i hela kronor';
    }
    if (so.cost > 10000) {
        return 'Fraktpris får inte vara större än 10 000 kr';
    }
    if (so.cost < 0) {
        return 'Fraktpris får inte vara mindre än 0';
    }
    return null;
}

function isInt(number) {
    return number % 1 === 0;
}
